import documentRoutes from './route';

export default documentRoutes;